import React from 'react';
import { Dropdown as AntDropdown } from 'antd';
import type { DropdownProps } from 'antd';
import clsx from 'clsx';

// NOTE: overlayClassName is the only antd Dropdown prop that reaches the
// portal-rendered panel; className does not, so wk-dropdown merges into it.
export const Dropdown = ({ overlayClassName, ...props }: DropdownProps) => (
  <AntDropdown
    {...props}
    overlayClassName={clsx('wk-dropdown', overlayClassName)}
  />
);

Dropdown.Button = AntDropdown.Button;
